import queryString from 'query-string'

import agent from 'agent'
import User from 'models/user'

const urlEncodedHeaders = {
  'Content-Type': 'application/x-www-form-urlencoded'
}

export default {
  fetchAll() {
    return agent.get('/users').then(({ data }) => toUserList(data))
  },

  activate(identifier) {
    return agent.put(`/users/${identifier}/activate`)
  },

  deactivate(identifier) {
    return agent.delete(`/users/${identifier}`)
  },

  changeRole(identifier, role) {
    return agent.put(
      `/users/${identifier}`,
      queryString.stringify({
        role
      }),
      { headers: urlEncodedHeaders }
    )
  },

  invite(email) {
    return agent.post('/users/invite', queryString.stringify({ email }), {
      headers: urlEncodedHeaders
    })
  },

  deleteInvite(invitedEmail) {
    return agent.delete(`/users/invite/${encodeURIComponent(invitedEmail)}`)
  }
}

function toUserList(data) {
  return Object.keys(data)
    .reduce((arr, value) => arr.concat(data[value]), [])
    .map((u) => new User(u))
}
